import React from "react";
import PageDefault from "../PageDefault";
import AddMovieForm from "../../components/AddMovieForm";

export function AddMovie() {
  return (
    <PageDefault>
      <AddMovieForm />
    </PageDefault>
  );
}

export default AddMovie;
